/**
 * Default scene settings that affect material shaders so we can avoid unnecessary shader recompilation.
 * @module
 */
import * as THREE from "three";

function genPlaceholderEnvMap(colorspace: THREE.ColorSpace) {
  const placeholderEnvCanvas = document.createElement("canvas");
  // The placeholder env map resolution should match the real env map resolution.
  placeholderEnvCanvas.width = 256;
  placeholderEnvCanvas.height = 256;
  const placeholderEnvImages: HTMLCanvasElement[] = [];
  for (let i = 0; i < 6; ++i) {
    placeholderEnvImages.push(placeholderEnvCanvas);
  }
  return new THREE.CubeTexture(
    placeholderEnvImages,
    THREE.CubeReflectionMapping,
    THREE.RepeatWrapping,
    THREE.RepeatWrapping,
    THREE.LinearFilter,
    THREE.LinearFilter,
    THREE.RGBAFormat,
    THREE.UnsignedByteType,
    1,
    colorspace,
  );
}

let placeholderEnvMap: THREE.CubeTexture | undefined;

/**
 * Apply physically rendered scene settings to prevent shader recompilation.
 * @param scene Scene to modify.
 */
export function applyDefaultPhysicalSceneSettings(scene: THREE.Scene) {
  scene.fog = new THREE.Fog(0x888888, 40000, 50000);
  if (!placeholderEnvMap) {
    placeholderEnvMap = genPlaceholderEnvMap(THREE.SRGBColorSpace);
  }
  scene.environment = placeholderEnvMap;
}
